// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-no-important */
.zj2JnDaAFGfZcN {
  display: flex;
  flex-direction: row;
  padding: var(--ds-space-0, 0) 6px;
  padding-bottom: var(--ds-space-300, 24px) !important;
  list-style: none;
}
.zj2JnDaAFGfZcN.wycqGsUtpKbch4 {
  transition: margin 0.2s ease-in-out, padding 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .zj2JnDaAFGfZcN.wycqGsUtpKbch4 {
    transition: unset;
  }
}
.zj2JnDaAFGfZcN._3zcUgV3VaWFBs4 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 65px !important;
}
.zj2JnDaAFGfZcN.O6HKn2OKShCwn8 {
  scrollbar-width: thin !important;
  margin-bottom: var(--ds-space-050, 4px) !important;
  padding-bottom: var(--ds-space-150, 12px) !important;
}
.zj2JnDaAFGfZcN.L2HRuPjKy4mgQH {
  margin-bottom: var(--ds-space-400, 32px) !important;
}
.zj2JnDaAFGfZcN.L2HRuPjKy4mgQH.yCwKvw4NFdxHBJ {
  margin-bottom: var(--ds-space-0, 0) !important;
  padding-bottom: calc(var(--ds-space-800, 64px) + var(--ds-space-100, 8px)) !important;
}
`, ""]);
// Exports
export var lists = `zj2JnDaAFGfZcN`;
export var animate = `wycqGsUtpKbch4`;
export var islandNavPadding = `_3zcUgV3VaWFBs4`;
export var islandOverlapEnabled = `O6HKn2OKShCwn8`;
export var islandOverlap = `L2HRuPjKy4mgQH`;
export var singlePanel = `yCwKvw4NFdxHBJ`;
export default ___CSS_LOADER_EXPORT___;
